import { Bone, SkeletonGrid, SkeletonCardTile } from '../primitives';

// Matches the pricing-card row shared by plans/Plans.js and plans/ChangePlan.js.
// `showToggle` defaults to true for the standalone/full-page case (RouteSkeleton,
// ChangePlan.js's top-level early returns); Plans.js already renders its own real
// monthly/annual toggle above this component, so it passes showToggle={false} to
// avoid a duplicate fake toggle appearing underneath the real one.
export default function PlansSkeleton({ cards = 4, showToggle = true }) {
    return (
        <div>
            {showToggle && (
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 24 }}>
                    <Bone h={30} w={140} r={999} />
                </div>
            )}
            <SkeletonGrid cols={cards} gap={16}>
                {Array.from({ length: cards }).map((_, i) => (
                    <SkeletonCardTile key={i} hasImage={false} lines={4} />
                ))}
            </SkeletonGrid>
        </div>
    );
}
